import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useDashboardFeatureFlags, useDashboardPermissions } from '@components'
import { TilesModal } from '@components/modals/TilesModal'
import { useModalContext } from '@fourthwall/components'
import { useCreateOfferMutation } from '@mutations'
import { reverse, routing } from '@utils/routing'

import { CreateBundleProductButton } from '../CreateBundleProductButton/CreateBundleProductButton'
import { CreateCombinedProductButton } from '../CreateCombinedProductButton/CreateCombinedProductButton'
import { CreateGiftCardProductButton } from '../CreateGiftCardProductButton/CreateGiftCardProductButton'
import { CreateSelfOwnedProductModal } from '../CreateSelfOwnedProductModal'
import * as S from './CreateProductModal.styled'
import designProductImage from './assets/design.png'
import digitalProductImage from './assets/digital.png'
import selfOwnedProductImage from './assets/selfOwned.png'

export const CreateProductModal = () => {
  const { createOfferMutation } = useCreateOfferMutation({
    onSuccess: ({ id }) => {
      close()
      navigate(`${reverse(routing.products.all.product.self, { productId: id })}${location.search}`)
    },
  })
  const navigate = useNavigate()
  const { hasRole } = useDashboardPermissions()
  const isAdmin = hasRole('ROLE_ORDER_WRITE') && hasRole('ROLE_SWITCH_SHOP_CONTEXT')
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const { open, close } = useModalContext()

  const combinedOfferEnabled = dashboardFeatureFlags.productCombinedOffer.enabled
  const bundleOfferEnabled = dashboardFeatureFlags.productBundleOffer.enabled
  const giftCardOfferEnabled = dashboardFeatureFlags.productGiftCard.enabled

  const handleProductDesignClick = () => {
    window.location.href = routing.productCatalog.self

    close()
  }

  const handleSelfOwnedProductClick = () => {
    const isUserAdmin = isAdmin

    if (isUserAdmin) {
      close()
      open(CreateSelfOwnedProductModal)
    } else {
      createOfferMutation.mutate([
        {
          name: 'New Product',
          description: '',
          price: { value: 30, currency: 'USD' },
          weight: { value: 10, unit: 'oz' },

          manufacturingService: 'MANUFACTURED_BY_CREATOR',
          settings: { requiresShipping: true },
        },
      ])
    }
  }

  const handleDigitalProductClick = () => {
    createOfferMutation.mutate([
      {
        name: 'New Digital Product',
        description: '',
        price: { value: 30, currency: 'USD' },
        weight: { value: 10, unit: 'oz' },

        manufacturingService: 'DIGITAL_ITEM',
        settings: { requiresShipping: false },
      },
    ])
  }

  return (
    <TilesModal
      heading="Create new product"
      isLoading={createOfferMutation.isLoading}
      itemsCount={3}
    >
      <TilesModal.Items>
        <TilesModal.Item
          image={designProductImage}
          imageAlt="Design a new product"
          heading="Design a new product"
          onClick={handleProductDesignClick}
        />
        <TilesModal.Item
          image={selfOwnedProductImage}
          imageAlt="Sell something I have"
          heading="Sell something I have"
          onClick={handleSelfOwnedProductClick}
        />
        <TilesModal.Item
          image={digitalProductImage}
          imageAlt="Sell digital product"
          heading="Sell digital product"
          onClick={handleDigitalProductClick}
        />
      </TilesModal.Items>
      {(combinedOfferEnabled || bundleOfferEnabled) && (
        <TilesModal.Footer>
          <S.Footer>
            <S.More>More</S.More>
            {bundleOfferEnabled && (
              <CreateBundleProductButton
                onSuccess={() => {
                  close()
                }}
              />
            )}
            {combinedOfferEnabled && (
              <CreateCombinedProductButton
                onSuccess={() => {
                  close()
                }}
              />
            )}
            {giftCardOfferEnabled && (
              <CreateGiftCardProductButton
                onSuccess={() => {
                  close()
                }}
              />
            )}
          </S.Footer>
        </TilesModal.Footer>
      )}
    </TilesModal>
  )
}
